import React, { useState }  from 'react';
import './Dashboard.css';
import DashboardHeader from './Header/DashboardHeader';
import DashboardSidebar from './Sidebar/DashboardSidebar';
import { Outlet } from "react-router-dom";
import ModalVideoInicial from "./Modalvideoinicial/modalvideoinicial";


const Dashboard = () => {
   // Estado para controlar la visibilidad de la sidebar
   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

   // Función para alternar la sidebar
   const toggleSidebar = () => {
     setIsSidebarOpen(!isSidebarOpen);
   };
   const closeSidebar = () => {
    setIsSidebarOpen(false); // Cierra la sidebar
  };

  return (
    <div className="Dashboard">
      <div className="dashboard-header">
    <DashboardHeader toggleSidebar={toggleSidebar} />
    </div>
    <div className={`dashboard-sidebar ${isSidebarOpen ? "open": ""}`}>
    <DashboardSidebar isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar} />
    </div>
    <div className="dashboard-content">
    <Outlet />
    </div>
    <ModalVideoInicial />
  </div>
  );
}

export default Dashboard;